<m-alert
  *ngIf="alertService.showAlert$ | async"
  [titleLabel]="alertService.title$ | async"
  [color]="alertService.color$ | async"
  [description]="alertService.description$ | async"
  (closed)="onCloseIconClick()"
  closeable>
  <m-icon [iconName]="alertService.icon$ | async" m-alert-icon></m-icon>
</m-alert>
